import { AVAILABLE_IMAGE_WIDTH, MAX_IMAGE_WIDTH, } from '../constants/image-sizes';
import { get } from 'lodash';
const isGif = (coverUrl) => /.gif$/.test(coverUrl);
const round100 = (width, height) => Math.round((width / height) * 100) / 100;
const cache = {};
export function getNormalizedCachedDimensions(coverUrl, { containerWidth, containerHeight, }) {
    const aspectRatio = round100(containerWidth, containerHeight);
    const cachedSizes = get(cache[aspectRatio], [coverUrl]);
    const loadedImageWidth = get(cachedSizes, 'width', 0);
    const loadedImageHeight = get(cachedSizes, 'height', 0);
    const widthCandidate = AVAILABLE_IMAGE_WIDTH.find((size) => size >= containerWidth) ||
        MAX_IMAGE_WIDTH;
    const width = isGif(coverUrl)
        ? MAX_IMAGE_WIDTH
        : Math.max(widthCandidate, loadedImageWidth);
    const heightCandidate = Math.round(width / aspectRatio);
    const height = Math.max(heightCandidate, loadedImageHeight);
    if (!cache[aspectRatio]) {
        cache[aspectRatio] = {};
    }
    cache[aspectRatio][coverUrl] = { width, height };
    return [width, height];
}
//# sourceMappingURL=normalize-image-dimensions.js.map